import { Grid } from 'common/layouts/grid/Grid';
import { Flex } from 'component-library/components/layout/Flex';
import { ResponsiveBody } from 'component-library/components/typography/ResponsiveBody';
import { ResponsiveHeading } from 'component-library/components/typography/ResponsiveHeading';
import { Screen } from 'component-library/components/wrappers/ShowOn';
import { colors } from 'component-library/styles/colors';
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';

import { body, heading } from './content';
import { Option, OptionVariant } from './Option';
import { OptionsWrapper } from './OptionsWrapper';

const Wrapper = styled.div`
  max-width: 1128px;
  padding: 120px 40px;
  margin: auto;
  position: relative;
`;

const Image = styled.div`
  padding-right: 65px;
  flex-basis: 45%;
`;

export const OptionsLarge = () => (
  <OptionsWrapper screens={[Screen.Lg, Screen.Xl, Screen.Xxl]} margin="0 40px">
    <Wrapper>
      <Flex marginBottom={80}>
        <Image>
          <StaticImage src="../images/options.webp" alt="smiling-man" />
        </Image>
        <Flex column justifyContent="center">
          <ResponsiveHeading variant={3} marginBottom={24} color={colors.white}>
            {heading}
          </ResponsiveHeading>
          <ResponsiveBody variant={1} marginBottom={48} color={colors.white}>
            {body}
          </ResponsiveBody>
        </Flex>
      </Flex>
      <Grid cols={3} gap={2}>
        <Option optionVariant={OptionVariant.SocialSecurity} />
        <Option optionVariant={OptionVariant.HealthCare} />
        <Option optionVariant={OptionVariant.Taxes} />
        <Option optionVariant={OptionVariant.Housing} />
        <Option optionVariant={OptionVariant.LegacyGoals} />
        <Option optionVariant={OptionVariant.Lifestyle} />
      </Grid>
    </Wrapper>
  </OptionsWrapper>
);
